import React, { useEffect } from 'react';
import { Stack, xcss } from '@atlaskit/primitives';
import { AnalyticsContext, useAnalyticsEvents } from '@atlaskit/analytics-next';
import RelatedUrlItem from '../related-url-item';
import { RelatedUrlItemAnalyticsContext, fireRelatedLinksViewedEvent } from './analytics';
var ResolvedResultsStack = function ResolvedResultsStack(_ref) {
  var resolvedResults = _ref.resolvedResults,
    testId = _ref.testId,
    renderers = _ref.renderers;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    // This event will fire each time the component is loaded
    fireRelatedLinksViewedEvent(createAnalyticsEvent)({
      relatedLinksCount: resolvedResults.length
    });
  }, [resolvedResults.length, createAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.050",
    testId: "".concat(testId, "-items-wrapper"),
    as: "ul"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ,
    xcss: xcss({
      paddingLeft: 'space.0',
      marginTop: 'space.0'
    })
  }, resolvedResults.map(function (resolvedResults, idx) {
    return /*#__PURE__*/React.createElement(RelatedUrlItemAnalyticsContext, {
      details: resolvedResults,
      key: idx
    }, /*#__PURE__*/React.createElement(RelatedUrlItem, {
      testId: "".concat(testId, "-item"),
      results: resolvedResults,
      renderers: renderers
    }));
  }));
};
var ResolvedResultsStackWithAnalytics = function ResolvedResultsStackWithAnalytics(props) {
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      component: 'relatedLinksSection'
    }
  }, /*#__PURE__*/React.createElement(ResolvedResultsStack, props));
};
export default ResolvedResultsStackWithAnalytics;